"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagWS = function FlagWS(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H4.74a7.06,7.06,0,0,1,7.06,7.06V5.12a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,5.12V-114.94a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-92.39-34.54l-3.24,9.72-10.25.08a1.38,1.38,0,0,0-.81,2.49l8.25,6.09-3.1,9.76a1.39,1.39,0,0,0,2.13,1.54l8.33-5.95,8.34,6A1.38,1.38,0,0,0-80.62-6.4l-3.09-9.76,8.24-6.09a1.38,1.38,0,0,0-.81-2.49l-10.25-.08-3.24-9.72a1.38,1.38,0,0,0-2.62,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-92.14-110.34l-2.62,7.87-8.29.06a1.11,1.11,0,0,0-.65,2L-97-95.47l-2.5,7.9a1.12,1.12,0,0,0,1.72,1.25l6.74-4.82,6.74,4.82a1.12,1.12,0,0,0,1.72-1.25l-2.5-7.9,6.67-4.93a1.12,1.12,0,0,0-.66-2l-8.29-.06L-90-110.34a1.12,1.12,0,0,0-2.12,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-50.21-86.95l-2.62,7.87-8.29.06a1.12,1.12,0,0,0-.65,2l6.66,4.92-2.5,7.91a1.12,1.12,0,0,0,1.72,1.24l6.74-4.82,6.75,4.82a1.11,1.11,0,0,0,1.71-1.24l-2.5-7.91L-36.52-77a1.12,1.12,0,0,0-.66-2l-8.28-.06-2.63-7.87a1.12,1.12,0,0,0-2.12,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-133.18-77.68l-2.63,7.87-8.29.06a1.12,1.12,0,0,0-.65,2l6.67,4.92-2.5,7.9a1.12,1.12,0,0,0,1.71,1.25l6.74-4.82,6.75,4.82a1.12,1.12,0,0,0,1.71-1.25l-2.5-7.9,6.67-4.92a1.12,1.12,0,0,0-.66-2l-8.29-.06-2.62-7.87a1.11,1.11,0,0,0-2.11,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-68.28-52l-1.47,4.41-4.66,0a.63.63,0,0,0-.36,1.14L-71-43.66l-1.4,4.44a.63.63,0,0,0,1,.7l3.79-2.71,3.78,2.71a.63.63,0,0,0,1-.7l-1.4-4.44,3.74-2.76A.63.63,0,0,0-61-47.56l-4.65,0L-67.09-52a.62.62,0,0,0-1.19,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagWS;
exports["default"] = _default;